import React, { useState } from 'react';
import styled from 'styled-components';
import { EntityWithLabel } from '../../../api/ApiTypes';
import { PopupTabs } from '../../../ui/PopupTabs';
import { Popup, PopupProps } from '../../popups/Popup';
import { Flexer } from '../elements/LayoutElements';
import { MemberInviteViaEmail } from './MemberInviteViaEmail';
import { MemberInviteViaLinkView } from './MemberInviteViaLinkView';

const Toggle = styled.div<{ visible: boolean }>`
    display: ${p => p.visible ? 'block' : 'none'};
`;

export const memberInvitePopup = (workspace: EntityWithLabel) => ({ ui: MemberInvitePopup, args: { workspace } });

export const MemberInvitePopup = ({ args, dismiss }: PopupProps) => {
    const workspace = args.workspace as EntityWithLabel;

    const [tab, setTab] = useState('email' as 'email' | 'link');

    return <Popup w={40}>
        <Popup.Close onAction={dismiss} />
        <Popup.Title>Add People To {workspace.label}</Popup.Title>
        <Popup.Content>
            <PopupTabs>
                <PopupTabs.Item onClick={() => setTab('email')} selected={tab === 'email'}>Via Email</PopupTabs.Item>
                <PopupTabs.Item onClick={() => setTab('link')} selected={tab === 'link'}>Via Link</PopupTabs.Item>
            </PopupTabs>
            <Flexer height="1" />
            <Toggle visible={tab === 'email'}>
                <MemberInviteViaEmail workspaceId={workspace.id} onClose={dismiss} />
            </Toggle>
            <Toggle visible={tab === 'link'}>
                <MemberInviteViaLinkView workspaceId={workspace.id} />
            </Toggle>
        </Popup.Content>
    </Popup>;
};
